/** Texto de ayuda — pantalla de acciones (Crear nuevo informe / Menú principal) */

export const TITULO_AYUDA_ACCIONES = {
  EVAL_INICIAL: "Ayuda — Evaluación Inicial",
  EVAL_PLAN: "Ayuda — Informe de Evaluación y Plan",
  EVAL_AVANCE: "Ayuda — Informe de avance",
};

export const SECCIONES_AYUDA_ACCIONES_COMUN = [
  {
    titulo: "¿Qué es esta pantalla?",
    parrafos: [
      "Es la pantalla intermedia entre el menú principal y el formulario del informe. Aquí confirma el paciente y el estudio de terapia, crea un informe nuevo o edita los que ya guardó.",
    ],
  },
  {
    titulo: "Datos que se muestran",
    lista: [
      "Paciente: nombre del paciente activo en este momento.",
      "Especialidad y rama: tipo de terapia del estudio (por ejemplo, OCUPACIONAL — Terapia Ocupacional).",
      "Inicio: fecha de inicio del estudio.",
      "Días: días de la semana en que el paciente asiste a terapia.",
    ],
  },
  {
    titulo: "Crear nuevo informe",
    parrafos: [
      "Abre el formulario en blanco para llenar y guardar el documento. Si el botón está deshabilitado (gris), lea el mensaje en pantalla: normalmente indica que ya existe un informe suyo para este estudio o que aún no cumple los requisitos de citas pagadas.",
    ],
  },
  {
    titulo: "Menú principal",
    parrafos: [
      "Regresa al menú de Tipos de Informe y Recomendaciones del mismo paciente. Si eligió al paciente desde la lista de pendientes, el nombre se mantiene al volver.",
    ],
  },
  {
    titulo: "Lista de informes guardados",
    parrafos: [
      "Si ya creó informes para este estudio, aparecen en la lista con fecha de modificación.",
    ],
    lista: [
      "Editar: abre el formulario con los datos guardados.",
      "Eliminar: borra el informe (se pedirá confirmación).",
    ],
  },
];

export const SECCIONES_AYUDA_EVAL_INICIAL = [
  {
    titulo: "Evaluación Inicial — particularidades",
    lista: [
      "Solo puede existir una Evaluación Inicial suya por estudio. Si ya la creó, «Crear nuevo informe» queda bloqueado y debe usar Editar en la lista.",
      "Si aparece «No hay informes guardados aún para este paciente», pulse Crear nuevo informe para abrir el formulario.",
      "Informes del paciente (todos los especialistas): si otro colega ya hizo una evaluación inicial del mismo paciente en otra terapia, puede usar «Utilizar datos» para copiar información como referencia y guardar su propio informe.",
    ],
  },
  {
    titulo: "En el formulario",
    lista: [
      "Complete los campos clínicos y pulse Guardar.",
      "Para imprimir el PDF necesita tener su firma digital cargada en el sistema.",
      "Volver lo regresa a esta pantalla de acciones.",
    ],
  },
];

export const SECCIONES_AYUDA_EVAL_PLAN = [
  {
    titulo: "Informe de Evaluación y Plan — particularidades",
    lista: [
      "Requiere haber creado antes la Evaluación Inicial y tener al menos 4 citas pagadas en el estudio.",
      "Solo puede tener un Informe de Evaluación y Plan suyo por estudio.",
      "En el formulario puede elegir formato infantil o escolar (Terapia Ocupacional).",
      "El botón «Ayuda Informe» con inteligencia artificial solo está disponible al crear el informe por primera vez, no al editar uno ya guardado.",
    ],
  },
];

export const SECCIONES_AYUDA_EVAL_AVANCE = [
  {
    titulo: "Informe de avance — particularidades",
    lista: [
      "Requiere tener creado el Informe de Evaluación y Plan.",
      "Puede crear hasta 4 informes de avance por estudio. La línea «Informes de avance: N de 4» indica cuántos lleva.",
      "Para cada avance nuevo se cuentan citas pagadas después de la fecha del Plan o del avance anterior: 16 citas si asiste 1 día por semana, 32 citas si asiste 2 días por semana.",
      "Si no puede crear otro avance, el mensaje indicará cuántas citas pagadas lleva y cuántas faltan desde la fecha de referencia.",
    ],
  },
];

export function seccionesAyudaAcciones(tipoInforme) {
  const comunes = SECCIONES_AYUDA_ACCIONES_COMUN;
  if (tipoInforme === "EVAL_PLAN") {
    return [...comunes, ...SECCIONES_AYUDA_EVAL_PLAN];
  }
  if (tipoInforme === "EVAL_AVANCE") {
    return [...comunes, ...SECCIONES_AYUDA_EVAL_AVANCE];
  }
  return [...comunes, ...SECCIONES_AYUDA_EVAL_INICIAL];
}

export function tituloAyudaAcciones(tipoInforme) {
  return TITULO_AYUDA_ACCIONES[tipoInforme] || "Ayuda — Informe clínico";
}
